import React from 'react';
import { useSelector } from 'react-redux';

import { getAEMMobileAppTeaserProps } from 'features/order-tracker/store/selectors';
import { formatAEMImageUri } from 'features/order-tracker/utils';

import appStoreBtn from 'assets/order-tracker/teaser_app_store_download_btn.svg';
import googlePlayBtn from 'assets/order-tracker/teaser_google_play_download_btn.svg';

import { ANALYTIC_ALT_TEXT_APP_STORE_BTN, ANALYTIC_ALT_TEXT_GOOGLE_PLAY_BTN, APP_NAME } from './constants';

import styles from './styles.module.scss';

export const Teaser: React.FC = () => {
  const AEMMobileAppTeaserProps = useSelector(getAEMMobileAppTeaserProps);

  if (!AEMMobileAppTeaserProps) {
    return null;
  }

  const {
    title,
    features,
    infoLinkLabel,
    infoLinkPath,
    description,
    appStoreLink,
    googlePlayLink,
    backgroundImage,
    qrCodeImage,
  } = AEMMobileAppTeaserProps;

  const formattedBgImgUri = formatAEMImageUri(backgroundImage);
  const formattedQrCodeUri = formatAEMImageUri(qrCodeImage);

  return (
    <div className={styles.teaserWrapper}>
      <picture className={styles.bgImage}>
        <source media="(min-width: 1280px)" srcSet={`${formattedBgImgUri}:1024x640`} />
        <source media="(min-width: 768px)" srcSet={`${formattedBgImgUri}:320x380`} />
        <source media="(min-width: 0px)" srcSet={`${formattedBgImgUri}:352x234`} />
        <img src={formattedBgImgUri} alt="title" loading="eager" />
      </picture>
      <div className={styles.teaserContainer}>
        <div className={styles.teaserInfo}>
          <h3 className={styles.teaserTitle}>
            {title.replace(APP_NAME, '')}
            <br />
            <span>{APP_NAME}</span>
          </h3>
          <ul className={styles.teaserList}>
            {features?.map((item: string) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <a
            href={infoLinkPath}
            className={styles.teaserLink}
            target="_blank"
            rel="noopener noreferrer"
            data-analytics-link={infoLinkLabel}
          >
            {infoLinkLabel}
          </a>
          <div className={styles.appInfo}>
            <p dangerouslySetInnerHTML={{ __html: description }} className={styles.teaserDescription} />
            <p>
              <a
                className={styles.teaserBtn}
                href={appStoreLink}
                target="_blank"
                rel="noopener noreferrer"
                data-analytics-link={ANALYTIC_ALT_TEXT_APP_STORE_BTN}
              >
                <img alt={ANALYTIC_ALT_TEXT_APP_STORE_BTN} src={appStoreBtn} />
              </a>
              <a
                href={googlePlayLink}
                target="_blank"
                rel="noopener noreferrer"
                data-analytics-link={ANALYTIC_ALT_TEXT_GOOGLE_PLAY_BTN}
              >
                <img alt={ANALYTIC_ALT_TEXT_GOOGLE_PLAY_BTN} src={googlePlayBtn} />
              </a>
            </p>
            <img src={`${formattedQrCodeUri}?fmt=png-alpha`} className={styles.qrCodeImage} alt="qr code" />
          </div>
        </div>
      </div>
    </div>
  );
};
